import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';
import PropTypes from 'prop-types';

const FileTypeDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedFileType, refreshData }) => {
    const initialFileTypeData = {
        id: '',
        title: '',
    };

    const [fileTypeData, setFileTypeData] = useState(initialFileTypeData);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isOpen) {
            if (mode === 'modify' && selectedFileType) {
                setFileTypeData({ ...initialFileTypeData, ...selectedFileType });
            } else {
                resetForm();
            }
            setErrors({});
        }
    }, [mode, selectedFileType, isOpen]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let processedValue = value;

        if (name === 'title' && typeof processedValue === 'string') {
            processedValue = processedValue.toLocaleUpperCase('tr-TR');
        }

        setFileTypeData(prevData => ({ ...prevData, [name]: processedValue }));

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        }
    };

    const validateForm = () => {
        const validationErrors = {};

        if (!fileTypeData.title?.trim()) {
            validationErrors.title = 'Dosya tipi başlığı zorunludur.';
        } else if (fileTypeData.title.trim().length < 2) {
            validationErrors.title = 'Başlık en az 2 karakter olmalıdır.';
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const resetForm = () => {
        setFileTypeData(initialFileTypeData);
        setErrors({});
    };

    const handleCancel = () => {
        resetForm();
        toggle();
    };

    const handleOperation = async () => {
        if (!validateForm()) {
            toast.error('Lütfen formdaki hataları düzeltin.');
            const firstErrorKey = Object.keys(errors).find(key => errors[key]);
            if (firstErrorKey) document.getElementById(firstErrorKey)?.focus();
            return;
        }

        const payload = {
            title: fileTypeData.title,
            ...(mode === 'modify' && selectedFileType?.id && { id: selectedFileType.id })
        };

        console.log("Sending Payload:", payload);

        try {
            await handleAddModifyOperation({
                apiEndpoint,
                selectedItem: mode === 'modify' ? { id: selectedFileType?.id } : null,
                mode,
                data: payload,
                refreshDataCallback: refreshData,
                componentName: 'Dosya Tipi',
            });
            toggle();
        } catch (error) {
            console.error("Dosya Tipi operasyonu başarısız:", error);
        }
    };

    const getModalTitle = () => {
        return mode === 'add' ? 'Dosya Tipi Ekle' : 'Dosya Tipi Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">Tür Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={fileTypeData.title || ''}
                            onChange={handleInputChange}
                            placeholder="Dosya Türü Adı"
                            invalid={!!errors.title}
                        />
                        <FormFeedback>{errors.title}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleOperation}>
                    {getButtonLabel()}
                </Button>
                <Button color="secondary" onClick={handleCancel} className="ms-2">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

FileTypeDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedFileType: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default FileTypeDataModal;
